var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05859 18.7031H7.58203C8.00273 18.7031 8.34375 18.3621 8.34375 17.9414C8.34375 17.5207 8.00273 17.1797 7.58203 17.1797H6.05859C5.6379 17.1797 5.29688 17.5207 5.29688 17.9414C5.29688 18.3621 5.6379 18.7031 6.05859 18.7031Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9414 11.0859H11.3141C10.9602 9.34968 9.42124 8.03906 7.58203 8.03906H6.05859C3.95953 8.03906 2.25 9.74855 2.25 11.8477V17.9414C2.25 20.0415 3.9585 21.75 6.05859 21.75H17.9414C20.0415 21.75 21.75 20.0415 21.75 17.9414V14.8945C21.75 12.7945 20.0415 11.0859 17.9414 11.0859ZM20.2266 17.9414C20.2266 19.2014 19.2014 20.2266 17.9414 20.2266H6.05859C4.79856 20.2266 3.77344 19.2014 3.77344 17.9414V11.8477C3.77344 10.6398 4.76611 9.5625 6.05859 9.5625H7.58203C8.84207 9.5625 9.86719 10.5876 9.86719 11.8477C9.86719 12.2684 10.2082 12.6094 10.6289 12.6094H17.9414C19.2014 12.6094 20.2266 13.6345 20.2266 14.8945V17.9414Z",
    fill: "#004E5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 9.5625C18.5144 9.5625 18.8555 9.22148 18.8555 8.80078V4.53516C18.8555 3.27512 17.8303 2.25 16.5703 2.25H7.42969C6.16965 2.25 5.14453 3.27512 5.14453 4.53516V5.75391C5.14453 6.1746 5.48555 6.51562 5.90625 6.51562C6.32695 6.51562 6.66797 6.1746 6.66797 5.75391V4.53516C6.66797 4.11514 7.00968 3.77344 7.42969 3.77344H16.5703C16.9903 3.77344 17.332 4.11514 17.332 4.53516V8.80078C17.332 9.22148 17.6731 9.5625 18.0938 9.5625Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/FolderOpen.dfdb9527941e335758b53350ae128f2e.svg";
export { ForwardRef as ReactComponent };